/**
 * Anillo de un círculo de `radiusKm` alrededor de `center` ([lng, lat]), para pintarlo
 * como polígono GeoJSON en Mapbox. Lo usan el mapa del buscador (radio de búsqueda) y el
 * de la sede en «Sedes».
 */
const circlePolygon = (
	center: [number, number],
	radiusInKm: number,
	points = 64
): [number, number][] => {
	const [longitude, latitude] = center
	const distanceX = radiusInKm / (111.32 * Math.cos((latitude * Math.PI) / 180))
	const distanceY = radiusInKm / 110.574

	const ring: [number, number][] = []

	for (let i = 0; i < points; i++) {
		const theta = (i / points) * (2 * Math.PI)
		ring.push([
			longitude + distanceX * Math.cos(theta),
			latitude + distanceY * Math.sin(theta),
		])
	}
	ring.push(ring[0])

	return ring
}

export default circlePolygon
